import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import Loading from "@/client/modules/solicitacoes/loading";
import { SolicitacoesClient } from "@/client/modules/solicitacoes/solicitacoes-client";

type Search = { todas?: string };

export const Route = createFileRoute("/app/solicitacoes")({
  validateSearch: (s: Record<string, unknown>): Search => ({ todas: s.todas as string | undefined }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("solicitacoes", "page", deps)),
  head: () => pageHead("Solicitações do site"),
  pendingComponent: Loading,
  component: SolicitacoesPage,
});

function SolicitacoesPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("solicitacoes", "page", search);
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Solicitações do site" description="Pedidos de agendamento enviados pelo formulário público." />
      <SolicitacoesClient rows={data.rows} currentUser={data.currentUser} funilOn={data.funilOn} />
      {data.hasMore && (
        <div className="flex justify-center">
          <Link
            to="/app/solicitacoes"
            search={{ todas: "1" }}
            className="rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 shadow-soft transition hover:bg-slate-50"
          >
            Ver solicitações antigas
          </Link>
        </div>
      )}
    </div>
  );
}
